import { getDealAndObjectType } from '../../../../../../shared/utils';

const DEAL_TYPES = {
  'sale': 'Продажа',
  'rent': 'Аренда',
};

const OBJECT_TYPES = {
  'flat': 'жилой',
  'commercial': 'коммерческой',
  'suburban': 'загородной',
};

export const getCategoryName = (state) => {
  const { offer: { category } } = state;

  const { dealType, objectType } = getDealAndObjectType(category);

  const dealTypeName = DEAL_TYPES[dealType];
  const objectTypeName = OBJECT_TYPES[objectType];

  return [dealTypeName, objectTypeName].join(' ');
};
